var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.50836,
    y: 54.0059,
    width: 70,
    height: 70,
    rx: 6,
    transform: "rotate(-45 4.50836 54.0059)",
    fill: "#F9FAFB",
    stroke: "#F7FCFD",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_1149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 54.0059,
    width: 64,
    height: 64,
    rx: 4,
    transform: "rotate(-45 8.75 54.0059)",
    fill: "url(#paint0_linear_139_1149)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_139_1149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1073 27.5425C52.7237 25.7376 55.2763 25.7376 55.8927 27.5425L61.8286 44.925C62.0287 45.511 62.489 45.9713 63.075 46.1714L80.4575 52.1073C82.2624 52.7237 82.2624 55.2763 80.4575 55.8927L63.075 61.8286C62.489 62.0287 62.0287 62.489 61.8286 63.075L55.8927 80.4575C55.2763 82.2624 52.7237 82.2624 52.1073 80.4575L46.1714 63.075C45.9713 62.489 45.511 62.0287 44.925 61.8286L27.5425 55.8927C25.7376 55.2763 25.7376 52.7237 27.5425 52.1073L44.925 46.1714C45.511 45.9713 45.9713 45.511 46.1714 44.925L52.1073 27.5425Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0537 27.8652C53.3621 26.9633 54.6379 26.9633 54.9463 27.8652L60.8818 45.248C61.182 46.127 61.873 46.818 62.752 47.1182L80.1348 53.0537C81.0367 53.3621 81.0367 54.6379 80.1348 54.9463L62.752 60.8818C61.873 61.182 61.182 61.873 60.8818 62.752L54.9463 80.1348C54.6379 81.0367 53.3621 81.0367 53.0537 80.1348L47.1182 62.752C46.818 61.873 46.127 61.182 45.248 60.8818L27.8652 54.9463C26.9633 54.6379 26.9633 53.3621 27.8652 53.0537L45.248 47.1182C46.127 46.818 46.818 46.127 47.1182 45.248L53.0537 27.8652Z",
    stroke: "url(#paint1_linear_139_1149)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_1149",
    x: 10.4069,
    y: 10.4079,
    width: 87.196,
    height: 87.1959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_1149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_139_1149",
    x: 26.1888,
    y: 26.1888,
    width: 55.6224,
    height: 59.6223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_1149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_1149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_1149",
    x1: 8.75,
    y1: 54.0059,
    x2: 77.5399,
    y2: 112.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#71AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A58D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_1149",
    x1: 22,
    y1: 22,
    x2: 90.7899,
    y2: 80.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#71AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A58D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.7808f4f08d6b9e7e8eed4721571930b8.svg";
export { ForwardRef as ReactComponent };